const MuiMultiSectionDigitalClock = {
    styleOverrides: {
        root: ({ theme })=>({
                '.Mui-selected': {
                    background: theme.palette.designSystem.green[50],
                    '&:hover': {
                        background: theme.palette.designSystem.green[150]
                    }
                }
            })
    }
};
export { MuiMultiSectionDigitalClock };

//# sourceMappingURL=multi-section-digital-clock-overrides.js.map